import { ref } from 'vue';

// использовать с этим компонентом
// import RouteLeaveModal from '@/components/common/RouteLeaveModal';
export function useRouteLeaveModalManual(formChangedStatuses, okFunc, cancelFunc) {
	const modalVisible = ref(false);
	const checkFormsChanged = () => {
		for (const value of Object.values(formChangedStatuses)) {
			if (value) {
				modalVisible.value = true;
				return true;
			}
		}
		return false;
	}

	const modalOk = () => {
		modalVisible.value = false;
		for (let key of Object.keys(formChangedStatuses)) {
			formChangedStatuses[key] = false;
		}
		okFunc();
	};
	const modalCancel = () => {
		modalVisible.value = false;
		cancelFunc();
	};

	return {
		modalVisible,
		checkFormsChanged,
		modalOk,
		modalCancel,
	};
}
